import React from 'react';
import {
  ChartLineUp,
  ShoppingCart,
  CurrencyDollar,
  Users,
  Package,
  Gear,
  Palette,
  ChartBar,
  ListMagnifyingGlass,
  Broadcast,
  Wrench,
  Storefront,
  Receipt,
  ChatCircleDots,
  Pulse,
  FileText,
} from '@phosphor-icons/react';

/**
 * Menú del sidebar del panel admin. Cada item apunta a una key que
 * usa Tabs internamente.
 */
export const ADMIN_NAV = [
  { key: 'overview',     label: 'Dashboard',       icon: ChartLineUp,   group: 'main' },
  { key: 'analytics',    label: 'Estadísticas',    icon: ChartBar,      group: 'main' },
  { key: 'payments',     label: 'Pagos pendientes',icon: Receipt,       group: 'operations', badge: 'pending' },
  { key: 'invoicing',    label: 'Facturación',     icon: FileText,      group: 'operations' },
  { key: 'orders',       label: 'Pedidos',         icon: ShoppingCart,  group: 'operations' },
  { key: 'customers',    label: 'Clientes',        icon: Users,         group: 'operations' },
  { key: 'users',        label: 'Usuarios',        icon: Users,         group: 'operations' },
  { key: 'services',     label: 'Servicios',       icon: Package,       group: 'catalog' },
  { key: 'pricing',      label: 'Precios',         icon: CurrencyDollar,group: 'catalog' },
  { key: 'content',      label: 'Contenido sitio', icon: Storefront,    group: 'site' },
  { key: 'integrations', label: 'Integraciones',   icon: Broadcast,     group: 'site' },
  { key: 'logs',         label: 'Logs',            icon: ListMagnifyingGlass, group: 'system' },
  { key: 'tools',        label: 'Herramientas',    icon: Wrench,        group: 'system' },
  { key: 'health',       label: 'Estado sistema',  icon: Pulse,         group: 'system' },
];

export const AdminSidebar = ({ active, onChange, pendingCount = 0, collapsed = false, onToggle }) => {
  return (
    <aside
      className={`sticky top-16 self-start shrink-0 h-[calc(100vh-4rem)] ${
        collapsed ? 'w-16' : 'w-60'
      } border-r border-border bg-card/50 transition-all duration-200 flex flex-col`}
      data-testid="admin-sidebar"
    >
      <div className="p-3 flex items-center justify-between">
        {!collapsed && <span className="text-xs uppercase tracking-widest text-muted-foreground">Admin</span>}
        <button
          onClick={onToggle}
          className="ml-auto p-1.5 rounded hover:bg-muted text-muted-foreground"
          aria-label="Toggle sidebar"
          data-testid="admin-sidebar-toggle"
        >
          <ChatCircleDots size={14} className={collapsed ? '' : 'rotate-180'} />
        </button>
      </div>
      <nav className="flex-1 overflow-y-auto px-2 pb-4 space-y-0.5">
        {ADMIN_NAV.map((item) => {
          const Icon = item.icon;
          const isActive = active === item.key;
          const badge = item.badge === 'pending' && pendingCount > 0 ? pendingCount : null;
          return (
            <button
              key={item.key}
              type="button"
              onClick={() => onChange(item.key)}
              data-testid={`admin-nav-${item.key}`}
              className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${
                isActive
                  ? 'bg-primary/10 text-primary font-medium'
                  : 'hover:bg-muted/70 text-foreground/80'
              }`}
              title={collapsed ? item.label : undefined}
            >
              <Icon size={18} weight={isActive ? 'fill' : 'regular'} className="shrink-0" />
              {!collapsed && (
                <>
                  <span className="flex-1 text-left truncate">{item.label}</span>
                  {badge != null && (
                    <span className="bg-red-500 text-white text-[10px] font-bold px-1.5 rounded-full min-w-[18px] h-4 flex items-center justify-center">
                      {badge > 99 ? '99+' : badge}
                    </span>
                  )}
                </>
              )}
              {collapsed && badge != null && (
                <span className="absolute w-2 h-2 rounded-full bg-red-500 mt-1 ml-4" />
              )}
            </button>
          );
        })}
      </nav>
    </aside>
  );
};
